export const restrictedFieldNames = [
  'id',
  'asset',
  'name',
  'assetname',
  'rectype',
  'createdat',
  'updatedat',
  'deleted',
  'category',
  'status',
  'assetstatus',
  'typeid',
  'assettype',
  'locationid',
]

export const containsRestrictedFieldName = (value) => {
  if (value && restrictedFieldNames.includes(value.trim().toLowerCase().replace(/\s+/g, ''))) {
    return true
  }
  return false
}
